<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="会員一覧" />
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="memberNo">
        <template v-slot:top>
        <v-form ref="form" lazy-validation>
          <v-toolbar flat color="white" class="mt-1">
                <v-text-field
                class="mr-3 pt-4"
                v-model="search"
                append-icon="mdi-account-search"
                label="氏名"
                />
                <v-text-field
                    class="mr-3 pt-4"
                    label="生年月日"
                    single-line
                    maxlength="10"
                    inputmode="tel"
                    type="tel"
                    @focus="focusDate(date)"
                    @input="date = $event"
                    :value="formatedDate(date)"
                    @keyup.delete="deleteKeyUp($event)"
                    @keyup="date = formatDate(date)"
                    :rules="[
                        rules.string_type,
                        rules.format_date,
                        rules.correct_date
                    ]"
                />
                <v-text-field
                    v-if="btn[5].isDisplay"
                    class="mr-3 pt-4"
                    v-model="card_no"
                    label="カード番号"
                    single-line
                />
                <v-select
                    v-if="modeStatus === 'user_div' && btn[5].isDisplay"
                    class="mr-3 selectWidth pt-4"
                    :items="Itemlist"
                    item-value="golf_code"
                    item-text="golf_name"
                    v-model="golf_code"
                    label="カード発行元のゴルフ場を選択"
                    :rules="[rules.required_golf_course]"
                ></v-select>
                <v-checkbox
                    v-if="btn[7].isDisplay"
                    class="mr-3 selectWidth pt-4"
                    v-model="completed"
                    label="未返信メッセージあり"
                />
            <v-spacer></v-spacer>
            <v-btn
                class="mr-2"
                color="primary"
                v-on:click="validateCheck"
                :disabled="btn[0].isActive"
                >検索</v-btn>
            <v-btn color="primary" class="mr-2" v-on:click="downloadCSV" :disabled="btn[1].isActive">CSV出力</v-btn>
            <v-btn color="primary" @click="MemberAddSetting(true)" :disabled="btn[2].isActive">会員追加</v-btn>
          </v-toolbar>
        </v-form>
        </template>
        <template v-slot:[`header.action`]>
            <div v-if="btn[3].isDisplay">詳細表示</div>
        </template>
        <template v-slot:[`header.MemberClassfication`]>
            <div v-if="btn[4].isDisplay">会員区分</div>
        </template>
        <template v-slot:[`header.cardRegister`]>
            <div v-if="btn[5].isDisplay">カード番号</div>
        </template>
        <template v-slot:[`header.point`]>
            <div v-if="btn[6].isDisplay">ポイント</div>
        </template>
        <template v-slot:[`header.message`]>
            <div v-if="btn[7].isDisplay">メッセージ</div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
                v-if="btn[3].isDisplay"
                @click="InfoMemberData(true, item)"
                :disabled="btn[3].isActive">mdi-account-edit
            </v-icon>
        </template>
        <template v-slot:[`item.MemberClassfication`]="{ item }">
            <a
                v-if="btn[4].isDisplay"
                @click="MemberClassficationOpen(true, item)"
                :class="{ 'disabled-btn': btn[4].isActive }">
                <img v-if="admin.user_div === 1" src="../../assets/golf_swing.png" width="24" style="margin-top: 6px;">
                <a v-else>{{ item.member_class_name }}</a>
            </a>
        </template>
        <template v-slot:[`item.cardRegister`]="{ item }">
          <v-icon v-if="btn[5].isDisplay" @click="MemberCardNoOpen(true,item)" :disabled="btn[5].isActive">mdi-card-bulleted-outline</v-icon>
        </template>
        <template v-slot:[`item.point`]="{ item }">
            <a
                v-if="btn[6].isDisplay"
                @click="PointHistoryOpen(true, item)"
                class="point_select"
                :class="{ 'disabled-btn': btn[6].isActive }">{{ item.point }}pt
            </a>
        </template>
        <template v-slot:[`item.message`]="{ item }">
            <v-icon
                v-if="item.display"
                :disabled="btn[7].isActive"
                @click="MessageListOpen(item.member_no)">mdi-message-text-outline
            </v-icon>
        </template>
      </v-data-table>
      <v-pagination
          class="my-2"
          v-model="page"
          :length="pageCount"
          :total-visible="7"
          @input="clickPagination"
      ></v-pagination>
    </v-card>
    <MemberModal ref="MemberAddView" @refresh-event="getMember"/>
    <MemberCard ref="MemberCardView" @refresh-event="getMember" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberClassfication ref="MemberClassficationView" @refresh-event="getMember" :golfCourseSelection="Itemlist" :golfCourseInput="golf_code"/>
    <MemberPointHistoryModal ref="PointHistoryView" @refresh-event="getMember" :adminInfo="admin" :golfGroupInfo="golf_groups" :golfCourseInput="golf_code"/>
    <MessageList ref="MessageView" @refresh-event="getMember" :adminInfo="admin" :golfCourseSelection="Itemlist"/>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import MemberModal from './modal/Member';
import MemberCard from './modal/MemberCard';
import MemberClassfication from './modal/MemberClassfication';
import MemberPointHistoryModal from './modal/MemberPointHistory';
import MessageList from './../Message/MessageList';
import validater from '@/lib/validater';

// サンプルデータ（ポイント残数）
// import SamplePointData from '../../assets/data/sample_point.json';

import { GET_MEMBER_LIST, MEMBER_LIST_INITIAL_DISPLAY } from '../../constants/member_list';
import { GET_POINT_TOTAL } from '../../constants/member_point_history';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';
import { GET_LOGIN_ADMIN } from '@/constants/login';

export default {
    components: {
        CardTitle,
        MemberModal,
        MemberCard,
        MessageList,
        MemberClassfication,
        MemberPointHistoryModal
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    props: ['name'],
    data () {
        return {
            page: 1,
            pageCount: 0,
            // 検索キーワード
            search: '',
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '会員No', value: 'member_no' },
                { text: '氏名', align: 'left', sortable: false, value: 'name' },
                { text: '性別', value: 'gender', sortable: false },
                { text: '生年月日', value: 'birth_date', sortable: false },
                { text: '詳細表示', align: 'center', value: 'action', sortable: false },
                { text: '会員区分', align: 'center', value: 'MemberClassfication', sortable: false },
                {
                    text: 'カード番号',
                    align: 'center',
                    value: 'cardRegister',
                    sortable: false
                },
                { text: 'ポイント', align: 'center', value: 'point', sortable: false },
                { text: 'メッセージ', align: 'center', value: 'message', sortable: false }
            ],
            // 生年月日の日付格納用
            date: '',
            // 生年月日のdate-picker用の値
            input_date: null,
            // ゴルフ場選択の制御
            modeStatus: '',
            // ポイントデータ格納用
            point_data: [],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            golf_code: null,
            begin_row: 0,
            limit_rows: 10,
            point_total: 0,
            card_no: null,
            add_card_no: null,
            completed: false,
            golfSelect: [],
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '検索', isActive: true, isDisplay: true },
                { element_id: '002', element_name: 'ＣＳＶ', isActive: true, isDisplay: true },
                { element_id: '003', element_name: '会員追加', isActive: true, isDisplay: true },
                { element_id: '004', element_name: '会員情報詳細表示', isActive: true, isDisplay: true },
                { element_id: '005', element_name: '会員区分詳細表示', isActive: true, isDisplay: true },
                { element_id: '006', element_name: 'カード番号詳細表示', isActive: true, isDisplay: true },
                { element_id: '007', element_name: 'ポイント詳細表示', isActive: true, isDisplay: true },
                { element_id: '008', element_name: 'メッセージ表示', isActive: true, isDisplay: true }
            ],
            vue_id: 'SCR0003',
            rules: {
                required_golf_course: value => this.isRequired(value) || this.$t('error.validation.required.whenCardNoIs'),
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        await this.$apollo.mutate({
            mutation: GET_LOGIN_ADMIN
        }).then(res => {
            this.admin.user_id = res.data.getLoginAdmin.user_id;
            this.admin.user_div = res.data.getLoginAdmin.login.user_div;
            this.admin.golf_code = res.data.getLoginAdmin.login.golf_code;
            return res.data.getLoginAdmin;
        });
        await this.initialFetch();

        this.admin.point_use_type = this.golf_groups[0].point_use_type;

        // システム管理者の場合
        if (this.admin.user_div === 1 && this.admin.point_use_type === 1) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golfSelect.unshift({ golf_code: '', golf_name: '' });
        } else if (this.admin.user_div === 1 && this.admin.point_use_type === 2) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golf_code = this.Itemlist[0].golf_code;
        } else {
        // ゴルフ場担当者
            this.Itemlist = [];
            this.Itemlist.push(this.golfSelect.find(el => el.golf_code === this.admin.golf_code));
            this.golf_code = this.admin.golf_code;
        }
        this.getMember();
        await this.getAuthorityByMemberList();
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
        initialFetch () {
            return this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: MEMBER_LIST_INITIAL_DISPLAY,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.golfSelect = res.data.getGolfCourse;
                this.golf_groups = res.data.getGolfGroupByMaster;
            });
        },
        getAuthorityByMemberList () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_OPERATION_ACCESSES_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                            if (list.display_control === 0) {
                                el.isDisplay = false;
                            } else {
                                el.isDisplay = true;
                            }
                        }
                    });
                };
            });
        },
        /** --------------------------------------------
        * 会員情報を取得
        * -------------------------------------------- */
        async getMember () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_MEMBER_LIST,
                        variables: {
                            name: this.search,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            birth_date: this.date,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows,
                            golf_code: this.golf_code,
                            card_no: this.card_no,
                            message_completed: this.completed
                        }
                    })
                    .then(res => {
                        const count = res.data.getMemberList.count;
                        this.pageCount = Math.ceil(count / this.limit_rows);
                        this.desserts = res.data.getMemberList.MemberList;
                        this.modeStatus = 'user_div';
                        this.add_card_no = null;
                        this.desserts.forEach(el => {
                            el.name = el.family_name + ' ' + el.given_name;
                            if (el.gender === 0) {
                                el.gender = '男性';
                            } else if (el.gender === 1) {
                                el.gender = '女性';
                            }
                        });
                    });
            } catch (error) {
                this.error = error;
            }
        },
        downloadCSV: async function () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_MEMBER_LIST,
                        variables: {
                            name: this.search,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            birth_date: this.date,
                            golf_code: this.golf_code,
                            card_no: this.card_no,
                            message_completed: this.completed
                        }
                    })
                    .then(res => {
                        let csvData = res.data.getMemberList.MemberList;
                        for (var i = 0; i < csvData.length; i++) {
                            csvData[i].name =
                csvData[i].family_name + ' ' + csvData[i].given_name;
                            if (csvData[i].gender === 0) {
                                csvData[i].gender = '男性';
                            } else if (csvData[i].gender === 1) {
                                csvData[i].gender = '女性';
                            }
                        }
                        var csv = '\ufeff' + '会員番号, 氏名, 性別, 生年月日\n';
                        csvData.forEach(el => {
                            var line =
                el['member_no'] +
                ',' +
                el['name'] +
                ',' +
                el['gender'] +
                ',' +
                el['birth_date'] +
                '\n';
                            csv += line;
                        });
                        let blob = new Blob([csv], { type: 'text/csv' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = this.DatetimeFormat() + '_会員一覧.csv';
                        link.click();
                    });
            } catch (error) {
                this.error = error;
            }
        },
        getPointTotal () {
            if (this.member_no) {
                this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_POINT_TOTAL,
                        variables: {
                            member_no: this.member_no,
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            golf_code: this.golf_courses_val
                        }
                    })
                    .then(res => {
                        if (res.data.getPointTotal[0].total_point) {
                            this.point_total = res.data.getPointTotal[0].total_point;
                        } else {
                            this.point_total = 0;
                        }
                    });
            }
        },
        isRequired (value) {
            if (this.card_no) {
                if (value) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUp (event) {
            this.date = this.formatDate(this.date);
            this.date = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                this.clickSearch();
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
        * 詳細表示ボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @item 子画面に渡す押下した行の各データ
        * ---------------------------------------------- */
        InfoMemberData (val, item) {
            this.$refs.MemberAddView.InfoMemberModal(val, item, 'checkData');
        },
        /** ----------------------------------------------
        * ポイント履歴参照ボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @memberNo 押下した行の会員ID
        * ---------------------------------------------- */
        MemberClassficationOpen: function (val, item) {
            this.$refs.MemberClassficationView.ModalControl(val, item);
        },
        /** ----------------------------------------------
        * 会員追加ボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        MemberAddSetting: function (val) {
            this.$refs.MemberAddView.ModalControl(val, 'addMember');
        },
        /** ----------------------------------------------
        * ポイントカード登録ボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @item 押下した行の会員情報
        * ---------------------------------------------- */
        MemberCardNoOpen: function (val, item) {
            this.$refs.MemberCardView.ModalControl(val, item);
        },
        /** ----------------------------------------------
        * ポイントボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @memberNo 押下した行の会員ID
        * ---------------------------------------------- */
        PointHistoryOpen: function (val, item) {
            this.$refs.PointHistoryView.ModalControl(val, item.member_no, item.member_rank);
        },
        /** ----------------------------------------------
        * メッセージボタン押下時の処理
        * @val 子画面に渡すモーダル表示制御値
        * @memberNo 押下した行の会員ID
        * ---------------------------------------------- */
        MessageListOpen: function (memberNo) {
            this.$refs.MessageView.ModalControl(memberNo);
        },
        /** ----------------------------------------------
     * 日時フォーマット（CSVファイル名用）
     * ---------------------------------------------- */
        DatetimeFormat: function () {
            var date = new Date();
            var str =
        date.getUTCFullYear() +
        ('0' + (date.getUTCMonth() + 1)).slice(-2) +
        ('0' + date.getUTCDate()).slice(-2) +
        ('0' + date.getUTCHours()).slice(-2) +
        ('0' + date.getUTCMinutes()).slice(-2) +
        ('0' + date.getUTCSeconds()).slice(-2);
            return str;
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getMember();
        },
        clickSearch: function () {
            this.page = 1;
            this.begin_row = 0;
            this.getMember();
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

</style>
